import { useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';

import AddEditProductDialog from './dialogs/AddEditProductDialog';
import Icn from '../components/Icn';
import Tx from "./Tx";
import { api } from "../maps/data.js";
import { colors } from '../maps/colors';
import { parseProductElementsAmount } from "./dialogs/ImportExcelDialog";
import { addOrDeleteQueryParams, getQueryValue } from "../domain/queryHandler";
import styles from './Product.module.css';

export default function Product(props) {
    const history = useNavigate();
    const location = useLocation();
    const [active, setActive] = useState(!!props.isActive);

    const productEditIdFromQuery = getQueryValue(location, 'productEditId');

    const { placementCount, isSelected, onSelectProduct, onNewProduct, onRemoveProduct, productActiveController, readonly } = props;

    const isEditMode = props._id === productEditIdFromQuery;

    const [open_edit_dialog, s_open_edit_dialog] = useState(isEditMode || false);

    const changeUrl = (query) => {
        history({
            search: query
        });
    }

    const editMode = () => {
        if (onSelectProduct) {
            onSelectProduct(props);
        } else {
            const urlToPush = addOrDeleteQueryParams(location, [
                {
                    productEditId: props._id
                }
            ]);

            changeUrl(urlToPush);
            s_open_edit_dialog(true);
        }
    }

    const editModeClose = () => {
        const urlToPush = addOrDeleteQueryParams(location, [
            {
                productEditId: null
            }
        ]);

        changeUrl(urlToPush);
        s_open_edit_dialog(false);
        props.refresh && props.refresh();
    }

    const toggleActivateProduct = async () => {
        await api({
            type: 'editProduct',
            data: {
                ...props,
                active: !active
            }
        });
        setActive(prevActive => !prevActive);
    }

    return (
        <Card sx={{ ...props.style, background: (active || isSelected) ? colors.LIGHT_GREEN : colors.WHITE, opacity: props.disabled ? 0.5 : 1 }}>
            <CardActionArea disabled={(readonly && !onSelectProduct) || props.disabled} onClick={editMode}>
                <div className={styles.container}>

                    {/* Product Type */}
                    <div className={styles.productTypeContainer}>
                        <Icn style={{ width: 16, height: 16, color: colors.GRAY3 }}>
                            {props.type === 'SHELF' ? 'shelfIcon' : 'hangerIcon'}
                        </Icn>
                    </div>

                    {/* Product AI */}
                    {props.hasAIModel && (
                        <div className={styles.productAIContainer}>
                            AI
                        </div>
                    )}

                    {/* Product Image */}
                    <CardMedia
                        component="img"
                        height="65"
                        image={props.imageUrl}
                        alt="product image"
                        className={styles.imageContainer}
                        sx={{ objectFit: 'contain' }}
                    />

                    {/* Product Details */}
                    <div className={styles.productDetailsContainer}>
                        <div className={styles.productName}>{props.name}</div>
                        <div className={styles.productInformation}>
                            <span>{props.avgWeight || 0} <Tx>product.gram</Tx></span>
                            {props.producedBy && (
                                <>
                                    <span>|</span>
                                    <span>{props.producedBy}</span>
                                </>
                            )}
                            {props.supplier && (
                                <>
                                    <span>|</span>
                                    <span>{props.supplier}</span>
                                </>
                            )}
                        </div>

                        {props.desc && (
                            <div className={styles.productDescription}>
                                {props.desc}
                            </div>
                        )}

                        <div style={{ fontSize: 8 }}>
                            {parseProductElementsAmount(props.amountOfElements)}
                        </div>
                    </div>

                    {/* Product Barcode Column */}
                    <div className={styles.columnContainer}>
                        {props.barcode}
                    </div>


                    {/* Product Price Column */}
                    <div className={styles.columnContainer}>
                        ₪ {props.price}
                    </div>

                    {productActiveController && (
                        <div style={{ position: 'absolute', right: 0, top: 0, padding: 10 }}>
                            <Icn onClick={(e) => {
                                e.stopPropagation();
                                toggleActivateProduct();
                            }}>{!active ? 'add' : 'delete'}</Icn>
                        </div>
                    )}

                    {placementCount >= 0 && (
                        <div style={{ lineHeight: '65px', fontSize: 32, fontWeight: 'bold' }}>
                            {placementCount}
                        </div>
                    )}
                </div>
            </CardActionArea>

            {open_edit_dialog && (
                <AddEditProductDialog
                    open={open_edit_dialog}
                    product={props}
                    onNewProduct={(newProduct) => {
                        onNewProduct(newProduct);
                    }}
                    onRemove={(productToRemove) => {
                        onRemoveProduct(productToRemove);
                    }}
                    onClose={editModeClose}
                />
            )}
        </Card>
    );
}